import { render, staticRenderFns } from "./InfoFilter.vue?vue&type=template&id=96ab57ae&scoped=true&"
import script from "./InfoFilter.vue?vue&type=script&lang=js&"
export * from "./InfoFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ab57ae",
  null
  
)

export default component.exports